import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSw: CultureInfo = {
  name: 'sw',
  displayName: 'Swahili',
  iso3LanguageCode: 'swa',
  iso2LanguageCode: 'sw',
  ietfLanguageTag: 'sw',
  parent: null
};
